import { w } from 'dist/Macros-CbPyZ4r2';
import { backgroundColour } from 'Shared/backend/Theme';

interface IStylesRule {
	location: string[],
	css?: any,
	fullPageWidth?: boolean,
	parallax?: boolean,
	border?;
	padding?;
};

type Styles = {
	[name:string]: IStylesRule[];
};


export function standardStyles(text): Styles
{
//TODO Probably better to have key/label pairs...
//XXX could have children to allow locations to specify sublocations. Probably better to implement eventually.
//XXX maybe support as 'posters:events' & 'posters:specials'
//XXX PROBABLY better done on a site basis... for the most part  TODO


	return {
/*				
		'No image margins on mobile': [{
			location: ['**','image'],
			noMarginsOnMobile: true
		}],
*/				
		'Full page width': [{
			location: ['*'],
			fullPageWidth: true
		}],
		'Parallax': [{
			location: ['*'],
			parallax: true
		}],
		//TODO separate out standard styles so we dont have to explicity include them
		'Standard page headings': [{
			location: ['**','*:Page heading','**','text:title'],
			css: text.pageTitle
		}],
		'Darken images 30%': [{
			location: ['**','image'],
			css: {
				filter: 'brightness(70%)'
			}
		}],
		'Darken images 20%': [{
			location: ['**','image'],
			css: {
				filter: 'brightness(80%)'
			}
		}],
		'Darken images 10%': [{
			location: ['**','image'],
			css: {
				filter: 'brightness(90%)'
			}
		}],
		'Brighten images 10%': [{
			location: ['**','image'],
			css: {
				filter: 'brightness(110%)'
			}
		}],
		'Brighten images 20%': [{
			location: ['**','image'],
			css: {
				filter: 'brightness(120%)'
			}
		}],
		'Brighten images 30%': [{
			location: ['**','image'],
			css: {
				filter: 'brightness(130%)'
			}
		}],
		'Overlay foreground background': [{
			location: ['**','overlay','foreground','*'],
			padding: {sides:'all',all:'2em'},
			css: {
				backgroundColor: 'rgba(0, 0, 0, 0.56)'
			}
		}],
		//XXX modelled off The Townie club page. 
		'Narrow page': [{
			location: ['^'],
			css: {
				maxWidth: 820,
				marginLeft: 'auto',
				marginRight: 'auto',
			}
		}],
		//XXX use in The Townie club page description. Should descriptions be left justified by default?
		'Left align': [{
			location: ['*'],
			css: {
				textAlign: 'left'
			}
		}],

		/* Examples:

		'Orange features': [{
				location: ['**','*:Featured','**','text'],
				css: {
					border: 'solid 10px orange'
				}
			}
		],
		'Pink special pages': [{
				location: ['^:Special page'],
				css: {
					backgroundColor: 'pink'
				}
			}
		],
		*/
	};
}

